export const textStrings = {
  myExercises: "My Exercises",
  nasmExercises: "NASM Exercises",
  edgeExercises: "EDGE Exercises",
  createNewLabel: "Create New:",
  circuit: "Circuit",
  superSet: "Super Set",
  sets: "Sets",
  workout: "Workout",
  workouts: "Workouts",
  program: "Program",
  programs: "Programs",
  circuits: "Circuits",
  superSets: "Super Sets", 
  exercise: "Exercise",
  exercises: "Exercises",
  libraries:"Libraries",
  supersetsCircuits: "Supersets & Circuits",
  loadError: "Unable to load exercises. Please try again.",
  somethingWentWrong: "Something went wrong. Please try again.",
  pleaseFillDetails: "Please fill all the details",
  repsCountError:"Please enter a reps count.",
};
